var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buypileh5-Container"},[_c('div',{staticClass:"bg"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.bg),expression:"bg"}],staticClass:"bg-item",attrs:{"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }